import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export const noSpinnerHeader = 'NO-SPINNER';
export const noSpinnerTrueValue = 'NO-SPINNER-TRUE';
export const noSpinnerFalseValue = 'NO-SPINNER-FALSE';

@Injectable()
export class SpinnerService {
    // MUST be static as Angular sometimes gives multiple instances of services.
    private static references = 0;

    // Subscribe to 'active' to receive spinner events.
    active = new Subject<boolean>();

    // Note: This is ONLY to be used in emergencies! (e.g. unhandled exceptions).
    // noinspection JSMethodCanBeStatic
    reset(): void {
        SpinnerService.references = 0;
        this.updateSubscribers();
    }

    // noinspection JSMethodCanBeStatic
    start(): void {
        SpinnerService.references = SpinnerService.references + 1;
        this.updateSubscribers();
    }

    // noinspection JSMethodCanBeStatic
    stop(): void {
        if (SpinnerService.references > 0) {
            SpinnerService.references = SpinnerService.references - 1;
        }
        this.updateSubscribers();
    }

    private updateSubscribers(): void {
        if (SpinnerService.references > 0) {
            this.active.next(true);
        } else {
            this.active.next(false);
        }
    }
}
